import { CardImage } from "components/card-image";

export const ListPage = ({
  list,
  onClickDetail,
  onClickPlus,
  showButtonPlus,
  locale,
  showDraft,
}) => {
  return (
    <div className="listPage-container">
      <div className="list">
        {list.map((news) => {
          return (
            <CardImage
              id={news.id}
              title={news.title}
              date={news.date}
              images={news.images}
              onClick={onClickDetail}
              locale={locale}
              key={news.id}
              state={news.state}
              showDraft={showDraft}
            />
          );
        })}
      </div>
      {showButtonPlus && (
        <div className="plus-container" onClick={onClickPlus}>
          <p>
            <span className="plus">+</span>
            <span>NEWS</span>
          </p>
        </div>
      )}
    </div>
  );
};
